import { createSlice } from '@reduxjs/toolkit'
import queryString from 'query-string'
import axios from '../../api/index'
import {
  failed,
  success,
} from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    list: [],
    current: {},
  },
  reducers: {
    usersFetched: (state, { payload }) => (
      { ...state, list: payload.data, total: payload.totalHits }
    ),
    userFetched: (state, { payload }) => ({ ...state, current: payload }),
  },
})

export default usersSlice.reducer

export const {
  usersFetched,
  userFetched,
  refereeGroupFetched,
} = usersSlice.actions

export const getUsers = (params, callBack) => (dispatch) => {
  const query = queryString.stringify(params, { arrayFormat: 'index' })
  dispatch(startLoading())
  axios.get('account/user', { params: new URLSearchParams(query) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(usersFetched(res?.data))
      if (callBack) callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      if (callBack) callBack()
    })
}

export const getUser = (userId) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'get',
    url: `account/user/${userId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(userFetched(res?.data.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e.response.data.message || 'مشکل در دریافت اطلاعات کاربر'))
    })
}

export const addUser = (data, successCallBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'post',
    url: 'account/user',
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('کاربر جدید اضافه شد'))
      if (successCallBack) successCallBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message || 'مشکلی پیش آمد. مجددا تلاش کنید'))
    })
}

export const editUser = (data, successCallBack) => async (dispatch) => {
  dispatch(startLoading())
  try {
    if (data.newPassword) {
      await axios({
        method: 'put',
        url: 'account/user/password/reset',
        headers: {
          'Content-Type': ' application/json',
        },
        data: {
          userName: data.userName,
          newPassword: data.newPassword,
        },
      })
    }
    await axios({
      method: 'put',
      url: 'account/user',
      headers: {
        'Content-Type': ' application/json',
      },
      data,
    })
    dispatch(stopLoading())
    dispatch(success('اطلاعات کاربر ویرایش شد'))
    if (successCallBack) successCallBack()
  } catch (error) {
    dispatch(stopLoading())
    dispatch(failed(error?.response?.data?.message || 'مشکلی پیش آمد. مجددا تلاش کنید'))
  }
}

export const deleteUser = (userId, successCallBack) => (dispatch) => {
  // const url = 'account/user'
  dispatch(startLoading())
  axios({
    method: 'DELETE',
    url: 'account/user',
    headers: {
      'Content-Type': ' application/json',
    },
    data: {
      userId,
    },
    // data: {
    //   user,
    // },
  })
  // axios.delete(url, { data: userId })
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('کاربر حذف شد'))
      if (successCallBack) successCallBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message || 'مشکلی پیش آمد. مجددا تلاش کنید'))
    })
}
